<template>
  <div>
    <v-card class="elevation-0 width" v-if="datasource.length > 0">
      <v-toolbar card dense color="transparent">
        <v-toolbar-title>
          <h4>Thông báo</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-list two-line class="pa-0">
          <template v-for="(item, index) in items">
            <v-subheader v-if="item.header" :key="item.id">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="index * 10000"></v-divider>
            <v-list-tile avatar v-else :key="item.id">
              <v-list-tile-avatar>
                <v-icon color="orange">{{getIcon(item.icon)}}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title v-html="item.title" :class="`${!item.isRead ? `bold` : ``}`"></v-list-tile-sub-title>
                <v-list-tile-sub-title
                  v-html="item.content"
                  :class="`${!item.isRead ? `bold` : ``}`"
                ></v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action class="caption">{{item.timeLabel}}</v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
        <v-divider></v-divider>
        <v-btn block flat class="ma-0" to="/notification">Xem tất cả</v-btn>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
    <div v-else class="background">
      <blank
        :src="`/static/icons/blank/news.png`"
        :firstLine="`Chưa có dữ liệu`"
        :secondLine="`Các cảnh báo từ xe sẽ được hiển thị tại đây`"
        :width="180"
      />
    </div>
  </div>
</template>

<script>
import Blank from '@/components/Blank';

export default {
  components: {
    Blank
  },
  props: {
    datasource: {
      type: Array,
      default: []
    }
  },
  data: () => ({
    items: this.datasource
  }),
  watch: {
    datasource () {
      this.items = this.datasource;
    }
  },
  methods: {
    handleClick: e => {},
    getIcon (icon) {
      let result = 'warning';
      if (icon) {
        switch (icon.toLowerCase()) {
          case 'lock':
            result = 'lock';
            break;
          case 'unlock':
            result = 'lock_open';
            break;
          case 'moving':
            result = 'near_me';
            break;
          case 'batalrm':
            result = 'battery_alert';
            break;
          case 'powercut':
          case 'turnon':
          case 'turnoff':
            result = 'power_settings_new';
            break;
          case 'connectionlost':
            result = 'signal_cellular_connected_no_internet_2_bar';
            break;
          case 'overspeed':
            result = 'network_check';
            break;
          case 'idle':
            result = 'local_parking';
            break;
          case 'illegalaccon':
            result = 'vpn_key';
            break;
          case 'vibration':
            result = 'vibration';
            break;
          case 'movein':
            result = 'input';
            break;
          case 'moveout':
            result = 'subdirectory_arrow_right';
            break;
          case 'news':
            result = 'email';
            break;
          case 'maintenance':
            result = 'build';
            break;
        }
      }
      return result;
    }
  }
};
</script>
<style scoped>
.width {
  max-width: 500px;
}
.bold {
  font-weight: bold;
}
.background {
  background: white;
  max-width: 360px;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/list/NotificationList.vue